import * as TagManager from "react-gtm-module";

TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });
const dataLayerPush = (dataLayer: any) => TagManager.dataLayer({ dataLayer });

export const ticketsViewed = (eventId: number, purchaseId: number | string | string[]) => {
  if (purchaseId) {
    dataLayerPush({ event: "tickets_viewed", event_id: eventId, purchase_id: purchaseId });
  } else {
    dataLayerPush({ event: "tickets_viewed", event_id: eventId });
  }
};

export const ticketsDownloaded = (purchaseId: number) => {
  dataLayerPush({ event: "tickets_downloaded", purchase_id: purchaseId });
};

export const genericPush = (analyticsUserId: string) => {
  dataLayerPush({ event: "generic_push", analytics_user_id: analyticsUserId });
};

export default TagManager;
